import requests from "../agent";

const Configuracion = {
    consultarParametro: (claveParametro) => requests.get(`/Configuracion/ConsultarParametro/${claveParametro}`),
    getParameter: (clave, idOrganization) => requests.get(`/ConfiguracionAnonymous/GetParemeter/${clave}/${idOrganization}`),
};

export default Configuracion;
